export const formatTextToHtml = (text: string): string => text ? text.replace(/\n/gu, '<br>') : '';

export const getInitialsFromName = (name?: string): string => (name ?? '').trim()
    .slice(0, 2)
    .toUpperCase();

/* eslint-disable id-length */
/* eslint-disable @typescript-eslint/no-magic-numbers */
/**
 * Returns a contrasting text color (#282829 or #FCFCFC) for a given hex background color.
 * Expects a 6-digit hex string prefixed with '#' (e.g. '#FF5733').
 */
export const getContrastColor = (bgColor: string): string => {
    const r = parseInt(bgColor.slice(1, 3), 16);
    const g = parseInt(bgColor.slice(3, 5), 16);
    const b = parseInt(bgColor.slice(5, 7), 16);

    const luminance = ((0.299 * r) + (0.587 * g) + (0.114 * b)) / 255;
    return luminance > 0.5 ? '#282829' : '#FCFCFC';
};
/* eslint-enable id-length */
/* eslint-enable @typescript-eslint/no-magic-numbers */
